import React, { Component } from 'react'
import { Bar } from 'react-chartjs-2';

 
const DATA_TYPE = {
  day: 0,
  month: 1,
  year: 2
}

class BarGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: getOption(props.unit),
      dataChart: {
        labels: [],
        datasets: [
          {
            label: 'Sample Data',
            data: [],
            backgroundColor: 'rgba(220, 199, 247, 1)',
            borderColor: 'rgba(220, 199, 247, 1)',
          }
        ]
      }
    };
  }

  componentDidMount() {
    this.setGraphData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setGraphData();
    }
  }

  setGraphData() {
    const { data, label, labelName } = this.props;

    this.setState({
      dataChart: {
        labels: label,
        datasets: [
          {
            label: labelName || 'data',
            data: data,
            backgroundColor: 'rgba(220, 199, 247, 1)',
            borderColor: 'rgba(220, 199, 247, 1)',
          }
        ]
      }
    });
  }

  render() {
    return (
      <Bar 
        data={this.state.dataChart}
        options={this.state.options}
      />
    );
  }
}


export default BarGraph;

function getOption(unit) {
  const unitText = unit || "";
  return {
    title: {
      display: false,
      fontSize: 20
    },
    legend:{
      display: false,
      position: 'right'
    },
    tooltips: {
      displayColors: false,
      callbacks: {
        title: function(tooltipItems, data) {
          return '';
        },
        label: function (tooltipItem, details) {
          let dataset = details.datasets[tooltipItem.datasetIndex];
          let currentValue = dataset.data[tooltipItem.index];
          return `${dataset.label} : ${currentValue}${unitText}`; 
        }
      }
    },
    scales: {
      xAxes: [{
        gridLines: {
          display: true,
          drawBorder: true,
          color: '#E5E5E5'
        },
        ticks:{
          fontSize : 11,
          fontColor : '#000',
          weight: "100",
          maxRotation: 0,
          userCallback: function(value, index, values) {
            return Number(value);
          }
        }
      }],
      yAxes: [{
        gridLines: {
          display: true,
          drawBorder: true,
          color: '#E5E5E5'
        },
        ticks:{
          fontSize : 11,
          fontColor : '#000',
          weight: "100", 
          beginAtZero: true,
          maxTicksLimit: 6,
          callback: function(value, index, values) {
            if (Math.floor(value) !== value) {
              return '';
            }
            return value;
          }
        }
      }],
    }
  }
}